module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cn"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_vm._v("David")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The traditional source of our understanding of this period is the Old Testament. The biblical narratives, however, were written from religious rather than historical perspectives. They were compiled long after the actual events had taken place and are subject to inconsistencies. Understandably, the biblical accounts have been subjected to rigorous academic challenges, and the material referring to David, the first king of the supposed United Monarchy of Judah and Israel, does not submit easily to critical historical examination."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-1",
      "id": "rfn2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Attempts to verify or add to the Old Testament version of events with archaeological evidence and or non-biblical records have largely disappointed, leading some to conclude that the populations of Judah and Israel were not sufficiently stable during the tenth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(" to support a comprehensive regional political entity."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-2",
      "id": "rfn2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In biblical terms, the pre-Israelite inhabitants of Jerusalem were a Canaanite tribe called Jebusites and their settlement was referred to as Jebus."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-3",
      "id": "rfn2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Whether or not the occupants of the hill country comprised the original twelve tribes of Israel, they were certainly in fierce conflict with the Philistines who were attempting to extend their sphere of influence."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-4",
      "id": "rfn2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" It was against this backdrop of struggle that Saul emerged as leader of the anti-Philistine factions. Saul’s kingdom was a loosely defined and administered territory, the inhabitants of which looked to him for protection."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-5",
      "id": "rfn2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The court was based about six miles north-east of Jerusalem, in a settlement/village known as Gibeah, and it was here that he was joined by David, a native of Bethlehem. The manner of David joining Saul’s court varies in different biblical stories, from innocent shepherd boy selected by Samuel, to musician, to giant slayer, but probably, he was simply a young professional soldier who became Saul’s armour bearer."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-6",
      "id": "rfn2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the exact dates are uncertain, towards the conclusion of the eleventh century and the early years of the tenth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(", events occurred that culminated with David taking Jerusalem. At some point "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("David fell out of favour at the royal household, and before the demise of Saul, David was variously a fugitive in hiding, leader of a private roaming army, and a mercenary serving A’chish, the king of the Philistine city-state of Gath."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-7",
      "id": "rfn2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" The Philistine army crushed Saul’s forces at the battle of Mount Gilboa"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-8",
      "id": "rfn2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" in the Jezreel Valley, and although Abner and Ishbosheth, surviving relatives of Saul, attempted to maintain leadership, effectively the reign of the house of Saul had ended with his death. For safety reasons the administration centre moved eastwards from Gibeah to Mananaim in the Transjordan."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-9",
      "id": "rfn2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps fortunately for the later legitimacy of his reign, due to fears that they might switch sides, David and his mercenaries were not allowed to fight alongside the Philistines at the battle which ended Saul’s life."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-10",
      "id": "rfn2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" David took advantage of the power vacuum that then existed and established a base eighteen miles south of Jerusalem, in the town of Hebron, where the southern Judean tribes appointed him to be their king."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-11",
      "id": "rfn2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Hostilities existed for some years between David and the house of Saul, but as time went on, the latter became increasingly impotent. Eventually both Abner and Ish-bosheth were assassinated, and in the end the northern Israelite tribes were left with no alternative other than to make peace with David and also anoint him as their king."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-12",
      "id": "rfn2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The independent city of Jerusalem, situated on the central north-south watershed, dominated the mountain crest route between David’s northern and southern kingdoms. Unsurprisingly, it became evident to David that this location would be ideal as his headquarters and administrative centre for both kingdoms. There were no apparent political ties between the Jebusites, who occupied Jerusalem’s south-eastern hill and any of the Jewish tribes. Accordingly, neither those in the north nor those in the south would have reason to be jealous or resent the founding of a new capital at Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the eastern slope of the Ophel ridge was the vitally important Gihon Spring. Although Jerusalem was fortified and protected by steep valleys on three sides, there is no mention of a siege or battle that enabled David to capture the city. The hypothesis that David’s army managed to gain surprise access to Jerusalem from the vicinity of the Gihon Spring stems from the biblical phrase: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("whoever would strike the Jeb’usites, let him get up the water shaft to attack.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-13",
      "id": "rfn2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" The mountain is formed from soluble limestone and dolomite and characterized by underground drainage systems and caves. During the latter years of the "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("eighth century  "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(", engineers were to adapt the natural fissures and crevices in the rock formation to facilitate the construction of a tunnel to divert the waters of the Gihon Spring. It is quite feasible, therefore, that David’s army found a way through these caves into Jerusalem to secure an easily defendable, populated and undamaged city."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-14",
      "id": "rfn2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jebusite Jerusalem now became the City of David situated on the Ophel (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Plates#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("figure 2")]), _vm._v("). Some confusion was created by a first-century ce source maintaining that David’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stronghold")]), _vm._v(" was on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("far higher")]), _vm._v(" hill,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-15",
      "id": "rfn2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" which can only mean the Western Hill. This assertion is mistaken as, of course, were later works that perpetuated the error. Numerous subsequent excavations have confirmed that the City of David was located east of the Tyropoeon Valley."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-16",
      "id": "rfn2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estimates of the area of the City of David have included 10.87 acres"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-17",
      "id": "rfn2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" and also "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("less than nine acres")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-18",
      "id": "rfn2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" An alternative estimate of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a bare 12 acres at most")]), _vm._v(" has been used together with an assumed density figure of 160– 200 persons per acre, to conclude that the population "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cannot have been much more than 2,400 (12")]), _vm._v("×"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("200) and probably numbered somewhat less, say 2,000")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-19",
      "id": "rfn2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In this hypothesis, no distinction was made between the inhabitants of the Jebusite settlement and David’s Jerusalem. If David’s army had captured the city without a bloody battle or mass exodus of Jebusites, neither of which are mentioned in the Old Testament, then the population would have been expanded by David’s soldiers and subsequently their wives and children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Notwithstanding that the Gihon Spring was outside the city walls, it is difficult to minimize the importance to Jerusalem of having its own supply of water. A different approach to the population question could be taken by considering how many people this source of spring water could support. After taking into account the amount that could reasonably be collected in buckets for domestic use, excluding natural wastage and irrigational outflows, and making a judicious estimate of daily consumption per head, a maximum population figure of 2,500 is indicated."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-20",
      "id": "rfn2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tradition has it that the ancient Israelites maintained a tented shrine containing Moses’ Ark of the Covenant. In the tenth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(" the shrine was situated possibly c.20 miles to the north of Jerusalem in the archaic walled city of Shiloh,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-21",
      "id": "rfn2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" or possibly c.10 miles to the west in Kiriathjearim. Wherever it was located, soon after the conquest, David organized the transfer of the Ark to a specially erected tent in Jerusalem."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-22",
      "id": "rfn2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" This not "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("only reinforced David’s position as protector of a unified Judean/Israelite cult, but also symbolized that henceforth the focal point and hub of the Jewish religion was in Jerusalem. Historically, threshing floors served as sites for holy rituals"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-23",
      "id": "rfn2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" and on the high hill to the north of the existing city walls, David built an altar on a threshing floor that he purchased from Araunah the Jebusite,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-24",
      "id": "rfn2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" who was possibly the king or ruler of Jerusalem when it fell to David."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-25",
      "id": "rfn2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" David’s payment of fifty shekels of silver suggests that this was a place of special significance, and it was here on Mt Moriah that David’s son Solomon would construct a temple complex to emphasize the might of the king and to worship Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lack of a centralized controlling power following the twelfth-century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")]), _vm._v(" collapse of Egyptian authority had possibly ended, or at least drastically curtailed state slavery and the corvée in Palestine."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-26",
      "id": "rfn2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" However, state slavery and civil obligations to carry out work for the crown became integral to David’s system of governance. Partly in order to facilitate such projects as the construction of his palace within the old Jebusite Ophel precinct, David instigated a census to register those liable for taxes, corvée and forced labour. An overseer named Adoram was assigned to take charge of the corvée and the coerced slave gangs, which included conquered peoples such as the Ammonites."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-27",
      "id": "rfn2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The traditional view is that David was the great warrior and his son Solomon was the accomplished builder and although these attributes did exist, the construction of David’s palace indicates that they were not mutually exclusive. David demonstrated his military prowess by successfully defending himself against the Philistines and conducted successful campaigns against the peoples of various surrounding territories such as the Moabs, the Edomites and the Ammonites, supported by Syrian mercenaries. In particular David conducted a successful war against Hadadezer, king of Zobah,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-28",
      "id": "rfn2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" and the kingdom of Aram-Damascus, which sent an army to assist Hadadezer. David bolstered his treasury with large amounts of bronze and shields made of gold, which he looted from Zobah. Additionally, the Syrians of Hamath, who had also been in conflict with Hadadezer, further rewarded David with articles of gold, silver and bronze."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-29",
      "id": "rfn2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Nevertheless, David’s contribution to the development of Jerusalem was principally political and it was left to Solomon to elevate the Iron Age town into an imposing city, principally by extending the city to the north and overseeing the construction of a magnificent Temple–Palace complex.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David was not viewed by the various settlements and tribal groups throughout Judah and Israel in the same way that they looked to Saul for protection against a common enemy. His kingdom was more of a city-state based in Jerusalem and, of course, there undoubtedly would have been some resentment of his rule. In an attempt to make his position more secure, David appointed loyal Levite priests from his original capital, Hebron, as administrators of the unified kingdom."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-30",
      "id": "rfn2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" His ruthlessness is illustrated by the handing over of seven of Saul’s male descendants to be executed by the Gibeonites."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-31",
      "id": "rfn2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" The biblical narrative"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-32",
      "id": "rfn2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" suggests that this was done to appease God and end a three-year famine or alternatively as retribution for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bloodguilt")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-33",
      "id": "rfn2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" incurred by Saul’s murderous treatment of the Gibeonites. Nevertheless, the elimination of so many of Saul’s lineage did eradicate a potential threat to David’s position, although this episode was bound to cause further bitterness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A revolt led by David’s son Absalom had such widespread support that David was obliged to temporarily leave Jerusalem, and even after the defeat and death of Absalom there was some uncertainty over whether or not David had enough support amongst the tribal leaders of Judah and Israel to assure his reinstatement."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-34",
      "id": "rfn2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" A malcontent named Sheba from the tribe of Benjamin led yet another rebellion that had to be suppressed before David’s rule in Jerusalem could once again be deemed secure."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-35",
      "id": "rfn2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Henceforth the underlying divisions within the united monarchy became more pronounced as the northern Israelite clans were subjected to discrimination in the form of punitive taxes and the imposition of forced labour."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-36",
      "id": "rfn2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As David neared the end of his life, his eldest surviving son Adonijah made a determined effort to ensure that it was he that was to accede to his Father’s throne. A very public and extravagant ceremony was arranged near En Rogel to sanction the progression of David’s eldest surviving son to the throne of Israel and Judah."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-37",
      "id": "rfn2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Nevertheless, David chose to grant his more favoured son, Solomon, the royal title of king."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn2-38",
      "id": "rfn2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Effectively, David and Solomon were co-rulers for a short period until David died in around 972 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(", but, importantly, Adonijah’s attempt to seize the throne had been circumvented and Solomon’s succession was ensured.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa536ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter02.vue
// module id = 81
// module chunks = 0